import React from "react";
import Box from "@mui/material/Box";
import { Subscription } from "rxjs";
import { Channel } from "../models/ChannelModel";
import { ChannelSquare } from "../components/Mosaic/ChannelSquare";
//import { SeparatorSquare } from "../components/Mosaic/SeparatorSquare";
import { acrAPI } from "../utils/api";
import { LICENSE_STATUS, License } from "../models/LicenseModel";
import { CreateChannelButton } from "../components/Mosaic/CreateChannelButton";
import { acrMonitorColors } from "utils/colors";
import { sortChannels } from "utils/utils";

export class Mosaic extends React.Component {
  public state = { license: new License(), channels: new Array<Channel>() };

  private subscribtions: Subscription = new Subscription();
  private prevGroup: string;
  private currentGroupColorIndex: number;
  private groupColors = [acrMonitorColors.GROUP_1, acrMonitorColors.GROUP_2];

  constructor(props: any) {
    super(props);    
    this.currentGroupColorIndex = 0;
    this.prevGroup = "";
    this.updateLicense = this.updateLicense.bind(this);
    this.updateChannels = this.updateChannels.bind(this);
  }

  public componentDidMount(): void {
    this.subscribtions.add(acrAPI.licenseSubject.subscribe(this.updateLicense));
    this.subscribtions.add(acrAPI.channelsSubject.subscribe(this.updateChannels));
  }

  public componentWillUnmount(): void {
    this.subscribtions.unsubscribe();
  }
  public shouldComponentUpdate(): boolean {
    return acrAPI.channelsSubject.getValue() !== this.state.channels;
  }
  private updateLicense(value: License): void {
    this.setState({ license: value });
  }
 
  private updateChannels(value: Array<Channel>): void {
    const dataChannels: Channel[] = sortChannels(value);
    this.setState({ channels: dataChannels });
  }

  private getGroupColor(channel: Channel, index: number): string {
    if(channel.group == null)
      channel.group = "";

    if(this.prevGroup != channel.group) {
      this.currentGroupColorIndex = (this.currentGroupColorIndex === 0) ? 1 : 0;
      this.prevGroup = channel.group;
    }
    let res = this.groupColors[this.currentGroupColorIndex];
    if(index === this.state.channels.length-1) {
      // Last channel: reset
      this.prevGroup = "";
      this.currentGroupColorIndex = 0;
    }
    return res;
  }

  public render(): JSX.Element {
    return (
      <Box style={{ display: 'flex', flexDirection: 'row', overflowY: 'auto', overflowX: 'hidden' }}>
        <CreateChannelButton disabled={acrAPI.channelsSubject.getValue().length >= 500} />
        <Box style={{ flexGrow: 1 }}>
          <Box display="flex" alignContent="flex-start" flexWrap="wrap" alignItems="center" style={{ overflow: "hidden" }}>
            {/* Liste de tuiles */}
            {this.state.channels.map((channel: Channel, index) => (
              <>
                {/* index > 0 && (channel.group !== this.state.channels[index - 1].group ?
                  (<SeparatorSquare visible={true} />) : (<SeparatorSquare visible={false} />)
                )*/}

                <ChannelSquare
                  mosaicIndex={index}
                  groupColor={this.getGroupColor(channel, index)}
                  key={channel.id}
                  channel={channel}
                  validLicense={!(this.state.license?.status === LICENSE_STATUS.ERROR)}
                  qualityIndexEnable={this.state.license.qualityIndexEnable}
                />
              </>
            ))}
          </Box>
        </Box>
      </Box>
    );
  }
}
